<div
  class="wd-100p tx-center align-items-center justify-content-center empty-field">
  <img src="/images/noresult.png" style="width: 25%;" alt="empty" />
  <p class="tx-bold">No Doubts added</p>
</div>
